import { buildSearchEngine, getOrganizationEndpoints, SearchEngine } from '@coveo/headless';
import isCoveoAnalyticsEnabled from './isCoveoAnalyticsEnabled';

// eslint-disable-next-line @typescript-eslint/ban-types
const featuredHeadlessEnginee: SearchEngine<{}> = buildSearchEngine({
  configuration: {
    organizationId:
      process.env.NEXT_PUBLIC_COVEO_ORG_ID || 'iqviafnaquintilesimsnonproduction12c6jth8d',
    accessToken:
      process.env.NEXT_PUBLIC_COVEO_FEATURED_ACCESSTOKEN ||
      'xx4bdcda38-b937-43a8-9c69-b9d8bd8e3db2',
    organizationEndpoints: getOrganizationEndpoints(
      process.env.NEXT_PUBLIC_COVEO_ORG_ID || 'iqviafnaquintilesimsnonproduction12c6jth8d'
    ),
    search: {
      searchHub: process.env.NEXT_PUBLIC_COVEO_FEATURED_TRIAL_SEARCHHUB || 'Featured Trials',
    },
    analytics: {
      enabled: isCoveoAnalyticsEnabled(),
      originLevel3:
        typeof window !== 'undefined'
          ? document.referrer || '/find-trials/search-result'
          : '/find-trials/search-result',
    },
  },
});

export default featuredHeadlessEnginee;
